/* eslint-disable import/no-anonymous-default-export */
import React from "react";

import {  Table,Message,Grid, Image, Label, Segment} from 'semantic-ui-react'
const ThankYou = () => {
  const list = [
    'You are all set, a confirmation email will be sent shortly.',
  
  ]
  
  return (
   
      <Grid divided='vertically' centered>
        <Grid.Row  verticalAlign="middle">
          <Grid.Column width={8} >
          <Segment>
        <Label as='a' color='orange' ribbon='right'>
          Hair Cut! 
        </Label>
        <Message header='John,Thank you!' list={list}/>
        <Table celled stackable>
    <Table.Header>
      <Table.Row>
       
        <Table.HeaderCell>Email</Table.HeaderCell>
        <Table.HeaderCell>Confirmation</Table.HeaderCell>
        <Table.HeaderCell>Date/Time</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      <Table.Row>
     
        <Table.Cell>Approved@approved.com</Table.Cell>
        <Table.Cell>FSD33f</Table.Cell>
        <Table.Cell>Dec23, 0100PM</Table.Cell>
      </Table.Row>
    </Table.Body>
  </Table>
      </Segment>
          </Grid.Column>
        </Grid.Row>
    

      </Grid>
    )
    
    
 
}
export default ThankYou;